import type {
  AdminPromoStats,
  PromoCampaignState,
  PromoPlanName,
  PromoRedemptionSourceName,
} from '@steado/admin-contract/promotions';

import type { ToneName } from '@/components/table/tone';

export const STATE_TONES: Readonly<Record<PromoCampaignState, ToneName>> = {
  scheduled: 'info',
  live: 'ok',
  ended: 'mute',
  archived: 'mute',
};

export const PLAN_LABELS: Readonly<Record<PromoPlanName, string>> = {
  annual: 'Annual',
  monthly: 'Monthly',
  both: 'Annual and monthly',
};

export const SOURCE_LABELS: Readonly<Record<PromoRedemptionSourceName, string>> = {
  app_claim: 'Typed in app',
  store_direct: 'App Store',
};

/**
 * An amount in the currency the store charged, in major units as RevenueCat
 * reports them. A code Intl does not know is shown as the bare figure and code
 * rather than throwing the whole row away.
 */
export function formatMoney(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format(amount);
  } catch {
    return `${String(amount)} ${currency}`;
  }
}

/** Revenue per currency, never summed across them: there is no rate to sum at. */
export function formatRevenue(revenue: AdminPromoStats['revenue']): string | null {
  if (revenue.length === 0) return null;
  return revenue.map((entry) => formatMoney(entry.amount, entry.currency)).join(' · ');
}
